import { useState, useEffect } from 'react';
import { empresasService, type Historial } from '@/services/empresas.service';

export function useHistorialEmpresa(nit: string) {
  const [data, setData] = useState<Historial[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!nit) return;

    const fetchHistorial = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await empresasService.getHistorialEmpresa(nit);
        setData(response.historial || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar historial de empresa');
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistorial();
  }, [nit]);

  return { data, isLoading, error };
}
